import { makeStyles } from "@material-ui/core/styles";
import { D11 } from "./contact360.constants";

// D8.4.1 — Estilos de ContactProfile360Modal (extraídos del god file).
export const useStyles = makeStyles((theme) => ({
  drawerPaper: {
    width: "min(920px, max(380px, 36vw))",
    maxWidth: "100%",
    height: "100%",
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column"
  },
  drawerHeader: {
    flexShrink: 0,
    display: "flex",
    alignItems: "center",
    padding: "14px 16px 12px",
    borderBottom: "1px solid rgba(0, 0, 0, 0.08)"
  },
  drawerScroll: {
    flex: 1,
    overflow: "auto",
    WebkitOverflowScrolling: "touch",
    padding: "12px 20px 24px",
    "&:focus": { outline: "none" }
  },
  kpiPaper: {
    padding: "10px 12px",
    textAlign: "center",
    borderRadius: 8,
    minHeight: 64,
    flex: "1 1 120px"
  },
  kpiValue: { fontWeight: 700, fontSize: 18, color: D11.blue },
  kpiOrange: { color: D11.orange },
  kpiGreen: { color: D11.green },
  bannerIa: {
    backgroundColor: "rgba(0, 200, 83, 0.09)",
    border: `1px solid ${D11.green}`,
    borderRadius: 8,
    padding: "10px 12px",
    marginBottom: 16
  },
  sectionTitle: {
    fontWeight: 700,
    marginTop: 16,
    marginBottom: 8,
    letterSpacing: 0.5,
    color: D11.blue
  },
  saveBtn: {
    backgroundColor: D11.green,
    color: "#fff",
    "&:hover": { backgroundColor: "#00a843" },
    marginTop: 24,
    width: "100%"
  },
  tabIndicator: {
    height: 3,
    backgroundColor: D11.blue
  },
  timelineEvent: {
    padding: "12px 14px",
    marginBottom: 10,
    borderRadius: 8,
    borderLeft: `3px solid ${D11.blue}`,
    backgroundColor: "#fafafa"
  },
  timelineDate: {
    fontSize: 12,
    color: D11.placeholder,
    marginBottom: 4
  },
  headerAvatarWrap: {
    position: "relative",
    display: "inline-block",
    flexShrink: 0
  },
  headerAvatarCam: {
    position: "absolute",
    bottom: 0,
    right: 0,
    backgroundColor: theme.palette.primary.main,
    color: "#fff",
    padding: 4,
    borderRadius: "50%",
    "&:hover": { backgroundColor: theme.palette.primary.dark }
  },
  hiddenFileInput: { display: "none" },
  avatarHeader: {
    width: 64,
    height: 64,
    minWidth: 64,
    minHeight: 64,
    "& img": { objectFit: "cover", width: "100%", height: "100%" }
  }
}));
